const postAddDocumentCompanies = {
  toastr: 'Documento agregado',
  toastr: 'El documento fue agregado con éxito'
};

export default postAddDocumentCompanies;
